/// <reference types="@types/googlemaps" />

import { Component, OnInit, ViewChild } from "@angular/core"; //AfterViewInit,
import { Router } from "@angular/router"; //, NavigationExtras
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { FormBuilder, Validators, FormArray, FormGroup } from "@angular/forms"; //FormGroup, FormControl,
import { HttpEvent, HttpEventType } from "@angular/common/http";
// PROVIDER
import { BasicProvider } from "../providers/basic/basic";
import { UserProvider } from "../providers/user/user";
//import { CommonService } from '../providers/common.service';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-pre-pull-package",
  templateUrl: "./pre-pull-package.component.html",
  styleUrls: ["./pre-pull-package.component.css"],
})
export class PrePullPackageComponent implements OnInit {

  homedash = 'warehouse';
  //pakg_status ='Delivered';
  pakg_status ='Warehouse';
  search_key ='';
  next_date = '';
  next_id = '';
  pickedList:any;
  warehouselist:any;
  hDataMore = true;
  pDataMore = true;
  hNoRecordFound = false;
  pNoRecordFound = false;
  package_status_ary:any;
  showPopup : boolean = false;
  popClass = '';
  inProcess = false;
  hLastId = '';
  hNoData = false;
  pLastId = '';
  pNoData = false;
  showFilter = false;
  selector = '';
  activeModal;
  file;
  uploadInProgress = false;
  uploadProgress = 0;
  hasValue = false;
  fileUploadType;
  warehouseId = [];
  lat = 51.678418;
  lng = 7.809007;
  constructor(
    public bp: BasicProvider,
    public up: UserProvider,
    public router: Router,
    public httpClient: HttpClient,
    public builder:FormBuilder,
    private modalService: NgbModal
    //private CommonService: CommonService
  ) {
    this.getPackageList('',false);
  }
  prePullPackageForm = this.builder.group({
    items: this.builder.array([])
  });

  form = this.builder.group({
    address: ['', [Validators.required]],
    additional_note:[''],
    image: ['', [Validators.required]],
    imgName: [''],
    // paymentReceipt: ['', [Validators.required]],
    warehouse_id: this.builder.array([])
  })
  formError;
  validation_message = {
    'address': {
      'required': 'Home address is required'
    },
    'image': {
      'required': 'Image is required.'
    },
    'paymentReceipt': {
      'required': 'Payment receipt is required.'
    },
    'additionalNote': {
      'required': 'Additional note is required.'
    }
  };

  ngOnInit() {
  }
  get itemsTypeArray() {
    return this.prePullPackageForm.get('items') as FormArray;
  }
  getPackageList( infiniteScroll : any = '', fromPaginate = false ){
    let api = 'warehouse/list';
		let searchFilter = {
      limit: 10,
      pakg_status: '',
      search_key : 8,
      next_id: '',
      type: "pre_pull"
    };

    if (this.pakg_status == 'Delivered') {
      if (fromPaginate) {
        searchFilter.next_id = this.pLastId;
      } else {
        this.pNoData = false;
      }

      if(this.pNoData){
        this.closeInfinete(infiniteScroll);
        return false;
      }
    } else {
      if (fromPaginate) {
        searchFilter.next_id = this.hLastId;
      } else {
        this.hNoData = false;
      }

      if(this.hNoData){
        this.closeInfinete(infiniteScroll);
        return false;
      }
    }

    //console.log(searchFilter);
    this.bp.hitApi(api, 'POST', searchFilter,true,true)
    .subscribe(
      (success) => {
        //console.log(success);
        if( success.type == true ){
          //success.data = [];
          this.manageListData(success,fromPaginate);
        }
        this.closeInfinete(infiniteScroll);
      },
      (error) => {
        this.manageListData('',fromPaginate);
        this.closeInfinete(infiniteScroll);
      }
    );

  }

  closeInfinete(obj){
    if(obj){
      //obj.complete();
    }
  }

  manageListData(data, fromPage){
    //console.log(data.package_status_ary);
    if(data.package_status_ary != ''){
      if(!this.package_status_ary){
        this.package_status_ary = data.package_status_ary;
        //this.acheader.update_package_status(this.package_status_ary);
      }
    }
    this.forHouse(data, fromPage);
  }

  forHouse(data, fromPage){
    console.log("data=====>", data);
    var index = data && data.data ? data.data.length-1: 0;

    if(data.data != '' && data.data.length>0){
      this.hNoRecordFound = false;
      this.hLastId = data.data[index].id;
      //console.log(data.data.length);
      if(!fromPage){
        this.warehouselist = data.data;
        this.warehouselist.forEach(element => {
          this.itemsTypeArray.push(
            this.builder.group({
              id: [element.id],
              full_name: [element.full_name],
              island_name: [element.island_name],
              address: [element.address],
              city: [element.city],
              country_name: [element.country_name],
              phone: [element.phone],
              package_status: [element.package_status],
              package_status_label: [element.package_status_label],
              added_warehouse_id: [element.added_warehouse_id || 0],
              added_pre_pull_packages_id: [element.added_pre_pull_packages_id || 0],
              selected: [false],
            })
          );
        });
      }
      else{
        this.warehouselist = this.warehouselist.concat(data.data);
        data.data.forEach(element => {
          this.itemsTypeArray.push(
            this.builder.group({
              id: [element.id],
              full_name: [element.full_name],
              island_name: [element.island_name],
              address: [element.address],
              city: [element.city],
              country_name: [element.country_name],
              phone: [element.phone],
              package_status: [element.package_status],
              package_status_label: [element.package_status_label],
              added_warehouse_id: [element.added_warehouse_id || 0],
              added_pre_pull_packages_id: [element.added_pre_pull_packages_id || 0],
              selected: [false],
            })
          );
        });
      }
    }
    else{
      if(!fromPage){
        this.warehouselist = data.data;
        if(data.data.length == 0){
          this.hNoRecordFound = true;
        }
      }
      this.hNoData = true;
      console.log('No more data');
    }
  }


  redirectNextPage(event, v, p){
    event.stopPropagation();
    if (v == 'd') {
      /*setTimeout(()=>{
        this.CommonService.sendData(p);
      },2000);*/
      this.up.tempWarehouseData = p;
      this.router.navigate(['addinvoive']);

    } else {
      this.router.navigate(['texdetail',p.id]);
    }

  }

  public beforeChange(tab_val: any) {

    if (tab_val=='picked') {

      this.pakg_status = 'Delivered';
    }else{
      this.pakg_status = 'Warehouse';
    }
    this.getPackageList('',false);
  }

  onScroll(infiniteScroll, fromPaginate = true ) {
    this.getPackageList( infiniteScroll, fromPaginate );
  }

  requestForDelivery(itemData, index){
    if(itemData.added_pre_pull_packages_id){
      alert('This package has already requested a pre pull.');
      const rateControl = this.itemsTypeArray.at(index);
      rateControl.patchValue({
        selected: false
      });
    }
  }

 validateItemCount(contentModal) {
    let selectedCount = 0;
    this.itemsTypeArray.value.forEach(item => (selectedCount += item.selected ? 1 : 0));
    if(!selectedCount){
      alert('Please select packages');
      return;
    }

    this.itemsTypeArray.value.forEach(item => {
      if(item.selected){
        this.warehouseId.push(item.id);
      }
    })
    let api = `warehouse/add_pre_pull_packages`;
    this.bp.hitApi(api, 'POST', {...this.form.value, warehouse_id: this.warehouseId}, true, true)
    .subscribe(
      (success) => {
        if (success.type == true) {
          this.bp.show_toast('Success', success.message);
          const roomControls = this.itemsTypeArray;
          for (let i = roomControls.length - 1; i >= 0; i--) {
            roomControls.removeAt(i);
          }
          this.getPackageList('');
        }
      });
/*
    this.form.reset();
    this.formError = '';
    this.activeModal =  this.modalService.open(contentModal);*/

  }
  closeModal(){
    this.activeModal.dismiss();
    this.form.reset();
  }

  get warehouseIds(): FormArray {
    return this.form.get('warehouse_id') as FormArray;
 }

  submit(){
    this.warehouseId = [];
    if (this.bp.validation(this.form, this.validation_message)) {


      this.itemsTypeArray.value.forEach(item => {
        if(item.selected){
          this.warehouseId.push(item.id);
        }
      })
      let api = `warehouse/add_pre_pull_packages`;
      this.bp.hitApi(api, 'POST', {...this.form.value, warehouse_id: this.warehouseId}, true, true)
      .subscribe(
        (success) => {
          if (success.type == true) {
            this.activeModal.dismiss();
            const roomControls = this.itemsTypeArray;
            for (let i = roomControls.length - 1; i >= 0; i--) {
              roomControls.removeAt(i);
            }
            this.getPackageList('');
          }
        });
    } else {
      this.formError = this.bp.validation_error;
    }
  }

  onchangeFile(event, fileType){
    this.fileUploadType = fileType;
    let allowFileType=['jpg', 'png', 'jpeg'];
    let selectedFileType =  event.target.files.length ? event.target.files[0].name.split('.').pop().toLowerCase() : '';
    if(!selectedFileType)
      return;

    if(!allowFileType.includes(selectedFileType)){
      this.bp.show_toast('Error', 'Please select correct file of allow format. Allowled format are jpg, png, jpeg');
      return;
    }

    let data = {location: 'users', type: 'IMAGE'};
    let api = `warehouse/upload_files`;
    const [file] = event.target.files;
    this.file = file;
    this.bp.hitApi(api, 'GET', data, true, true)
      .subscribe(
        (success) => {
          this.hasValue = true;
          console.log("data=====-->", success);
          if (success.type == true) {
            this.bp.upload(success.data[0].url, file, null, true)
            //.pipe(finalize(() => this.isBusy = false))
            .subscribe(
              (event: HttpEvent<any>) => {
                  switch (event.type) {
                    case HttpEventType.Sent:
                      this.uploadInProgress = true;
                      break;
                    case HttpEventType.UploadProgress:
                      this.uploadProgress = Math.round(100 * event.loaded / event.total);
                      break;
                    case HttpEventType.Response:
                      this.resetUploadProgress();
                      this.file = undefined;
                      this.hasValue = true;
                      if(fileType == 'uploadId'){
                        this.form.patchValue({
                          image: success.data[0].location,
                          imgName: success.data[0].location.split('/').pop()
                        })
                      } /*else {
                          this.form.patchValue({
                            paymentReceipt: success.data[0].location
                          })
                      }*/
                  }
              })

          } else {
            this.bp.show_toast('Error',success.message);
          }
        })
  }

  private resetUploadProgress() {
    this.uploadInProgress = false;
    this.uploadProgress = 0;
  }


}



// WEBPACK FOOTER //
// ./src/app/pre-pull-package/pre-pull-package.component.ts